module.exports = __webpack_public_path__ + "img/d.56b2bb8b.png";